/**
 * @generated SignedSource<<6075e07a665fd26e88499f87b5a46440>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionTodoIssue_todo$data = {
  readonly category: {
    readonly icon: TodoCategoryIcon | null;
    readonly isDefault: boolean;
    readonly title: string;
  } | null;
  readonly id: string;
  readonly subject: {
    readonly " $fragmentSpreads": FragmentRefs<"TodoSubjectIcon_TodoSubject">;
  } | null;
  readonly teams: ReadonlyArray<{
    readonly color: string | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemHeaderWrapper_todo" | "TodoListItem_todo">;
  readonly " $fragmentType": "RoutineOccasionTodoIssue_todo";
};
export type RoutineOccasionTodoIssue_todo$key = {
  readonly " $data"?: RoutineOccasionTodoIssue_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionTodoIssue_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionTodoIssue_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoSubjectIcon_TodoSubject"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHTeamIcon"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemHeaderWrapper_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItem_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "1f5401248faaf3aac49f1e5c144efdb9";

export default node;
